import axios from "../api/axiosInstance";

export const GetAllOrder = async () => {
    return await axios.get("/Order/GetOrderList");
};

export const GetOrderById = async (id) => {
    return await axios.get("/Order/GetOrderById", {
        params: { id }
    });
};

export const GetOrderByOrderNumber = async (orderNumber) => {
    return await axios.get("/Order/GetOrderByOrderNumber", {
        params: { orderNumber }
    });
};

export const GetOrdersByCustomer = async (customerId) => {
    return await axios.get("/Order/GetOrdersByCustomer", {
        params: { customerId }
    });
};

export const GetOrdersByEmployee = async (employeeId) => {
    return await axios.get("/Order/GetOrdersByEmployee", {
        params: { employeeId }
    });
};

export const GetOrdersByStatus = async (status) => {
    return await axios.get("/Order/GetOrdersByStatus", {
        params: { status }
    });
};

export const GetOrdersByDateRange = async (from, to) => {
    return await axios.get("/Order/GetOrdersByDateRange", {
        params: {
            from,
            to
        }
    });
};

export const AddOrder = async (model) => {
    return await axios.post("/Order/AddOrder", model);
};

export const UpdateOrder = async (model) => {
    return await axios.post("/Order/UpdateOrder", model);
};

export const RemoveOrder = async (id) => {
    return await axios.post("/Order/RemoveOrder", null, {
        params: { id }
    });
};

export const ChangeOrderStatus = async (orderId, status) => {
    return await axios.post("/Order/ChangeStatus", null, {
        params: {
            orderId,
            status
        }
    });
};

export const RecalculateOrderPrice = async (id) => {
    return await axios.post(`/Order/${id}/recalculate-price`);
};